// Müşteri portalı kabuğu — üst barda müşteri logosu/adı + çok firmalı seçici (K8, Finar
// 2026-10-23). Yanıtlar BİLİNÇLİ OLARAK dardır: branding'in yalnız iki alanı (ad + logo proxy
// adresi) müşteriye gider; renk/font/üst-alt bilgi şablonları vb. hiçbir alan sızmaz.

import { z } from "zod";

/** `GET /api/v1/portal/firms` satırı — müşterinin adına çalışabildiği firma. */
export const PortalFirmSchema = z.object({
  clientId: z.string().uuid(),
  clientName: z.string(),
});
export type PortalFirm = z.infer<typeof PortalFirmSchema>;

export const PortalFirmsResponseSchema = z.object({
  firms: z.array(PortalFirmSchema),
});
export type PortalFirmsResponse = z.infer<typeof PortalFirmsResponseSchema>;

/** `GET /api/v1/portal/branding?clientId=` — yalnız bu iki alan (allowlist). */
export const PortalBrandingSchema = z.object({
  clientName: z.string(),
  /** `/api/v1/files/...` proxy adresi; müşteri markası etkin değil ya da logo yoksa null. */
  logoUrl: z.string().nullable(),
});
export type PortalBranding = z.infer<typeof PortalBrandingSchema>;
